module.exports = __webpack_public_path__ + "img/banner01.6dec3718.webp";